/* EN-4396: the route roots whose pages can show every division of the account
   (the account level). Every other page shows the current division only, and
   says so (AccountLevelNotice). Add a root here when its page supports it. */
export const ACCOUNT_LEVEL_PAGES: readonly string[] = ['/app/orders'];

/* Pages that support the account level on that exact path only: the paths
   below them (a storage provider's own page) still show one division. */
export const ACCOUNT_LEVEL_EXACT_PAGES: readonly string[] = [
  '/app/catalogs/catalog',
  '/app/scm/storage-provider',
  '/app/dashboard/awaiting-actions',
  '/app/shipments',
];

/* A V2 catalog item (/app/catalogs/catalog/<uuid>) supports the account level;
   a legacy item (/app/catalogs/catalog/<24-hex Mongo id>: old links and
   bookmarks) shows one division. Same uuid test the API uses for V2 item ids
   (isV2ItemId in features/catalog-details/lib/v2.ts on client-production),
   kept local so account-view does not import catalog-details. */
const V2_CATALOG_ITEM =
  /^\/app\/catalogs\/catalog\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True for a supported root itself or a path below it, never a mere prefix. */
export function supportsAccountLevel(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  return (
    ACCOUNT_LEVEL_EXACT_PAGES.includes(path) ||
    V2_CATALOG_ITEM.test(path) ||
    ACCOUNT_LEVEL_PAGES.some(
      root => pathname === root || pathname.startsWith(`${root}/`),
    )
  );
}
